var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67863 0.574784C4.91295 0.340469 5.29285 0.340469 5.52716 0.574784L7.93132 2.97895L10.0527 0.857575C10.287 0.62326 10.6669 0.62326 10.9012 0.857574C11.1355 1.09189 11.1355 1.47179 10.9012 1.7061L8.77985 3.82747L12.174 7.22159L14.2953 5.10022C14.5296 4.8659 14.9095 4.8659 15.1439 5.10022C15.3782 5.33453 15.3782 5.71443 15.1439 5.94874L13.0225 8.07011L15.4267 10.4743C15.661 10.7086 15.661 11.0885 15.4267 11.3228C15.1923 11.5571 14.8124 11.5571 14.5781 11.3228L13.5882 10.3329L11.4385 12.4825C9.39494 14.5261 6.16481 14.66 3.96568 12.8843L1.426 15.424C1.19168 15.6583 0.811784 15.6583 0.577469 15.424C0.343155 15.1897 0.343155 14.8098 0.577469 14.5754L3.11715 12.0358C1.34141 9.83663 1.47534 6.6065 3.51895 4.56289L5.66858 2.41326L4.67863 1.42331C4.44432 1.189 4.44432 0.809099 4.67863 0.574784ZM6.51711 3.26179L4.36748 5.41142C2.64917 7.12973 2.64917 9.91565 4.36748 11.634C6.08579 13.3523 8.87171 13.3523 10.59 11.634L12.7396 9.48433L11.7497 8.49438L7.50706 4.25174L6.51711 3.26179Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.07f7074afb17e7b0120eb6f3b72ca3de.svg";
export { ForwardRef as ReactComponent };